export default "__VITE_ASSET__0afe36ab__"